import axios from 'axios';

import { ConversationDto } from '@tallo/investor/conversation';
import { TimeFilter } from '@tallo/utility';

import { PropertyInquiryDto } from '../model/property-inquiry.interface';

class PropertyInquiriesService {
  async getAllInquiriesByRenter(renterId: string): Promise<PropertyInquiryDto[]> {
    const response = await axios.get<PropertyInquiryDto[]>(`property-inquiry/inquiries/renter/${renterId}`);

    return response.data;
  }

  async getInquiryConversation(inquiryId: string): Promise<ConversationDto> {
    const response = await axios.get<ConversationDto>(`property-inquiry/conversation/${inquiryId}`);

    return response.data;
  }

  async getAllInquiriesByProperty(propertyId: string, filter?: TimeFilter): Promise<PropertyInquiryDto[]> {
    const response = await axios.get<PropertyInquiryDto[]>(`property-inquiry/inquiries/property/${propertyId}`, {
      params: {
        filter,
      },
    });

    return response.data;
  }
}

export default new PropertyInquiriesService();
